import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconWarning from '@/icons/Warning.svg';

export const RefusedByClientBadge = () => {
  return (
    <Badge color="warning" size="small">
      <IconWarning />
      <Trans id="action-dropdown-item.refused-by-client">Refused by client</Trans>
    </Badge>
  );
};
